import React from "react";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import "../styles/auth.css";

const PrivacyPolicy = () => {
  return (
    <div className="legal-container">
      <Navbar />

      <div className="legal-content">
        <h1>Privacy Policy</h1>

        <p>Last Updated: March 2026</p>

        <h2>1. Information We Collect</h2>
        <p>
          When you create an account or make a purchase on Mark & Luth, we may
          collect personal information such as your name, email address,
          shipping address, and payment details.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          We use the collected information to process orders, provide customer
          support, improve our services, and communicate important updates.
        </p>

        <h2>3. Account Security</h2>
        <p>
          You are responsible for maintaining the confidentiality of your
          account credentials. We recommend using strong passwords.
        </p>

        <h2>4. Sharing Information</h2>
        <p>
          We do not sell your personal data. Your information may only be shared
          with trusted partners such as payment processors and delivery
          services to complete your orders.
        </p>

        <h2>5. Cookies</h2>
        <p>
          Our website may use cookies to improve user experience and analyze
          website traffic.
        </p>

        <h2>6. Data Protection</h2>
        <p>
          We take reasonable steps to protect your personal information from
          unauthorized access or misuse.
        </p>

        <h2>7. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be
          posted on this page.
        </p>

        <h2>8. Contact Us</h2>
        <p>
          If you have questions regarding this Privacy Policy, please contact
          us through our website.
        </p>

      <h2>Payment Information</h2>
        <p>
        All payments are processed through secure payment gateways.
        Mark & Luth does not store your card or payment details.
        </p>
        <p>
Your information may also be shared with secure payment gateway
providers such as Razorpay to process transactions safely.
</p>




      </div>

      <BottomNav />
    </div>
  );
};

export default PrivacyPolicy;